import {Button} from '../atoms/Button';
import {Typography} from '../atoms/Typography';
import {Modal} from '../organisms/Modal';
import {CloseLineIcon} from '../svg/CloseLineIcon';

/*
 Displays a List of buttons
 Accepts a message and an optionsList containing labels and actions.
 */

export const ActionSheetDrawer = (props) => {
  const {
    children,
    isOpen,
    onClose,
    optionsList,
    showCancel = true,
    title,
    message,
    ...extraProps
  } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="EviteModal__Content ActionSheetDrawer"
      bodyOpenClassName="ReactModal__Body--open--allow-scroll"
      {...extraProps}
    >
      <div className="actionsheet-title-row">
        {!!title && (
          <Typography variant="label2" size="medium">
            {title}
          </Typography>
        )}
        <Button data-qa-id="overlay-close" variant="transparent" onClick={onClose}>
          <CloseLineIcon ratio={0.75} />
        </Button>
      </div>

      <ol className="ActionSheetDrawer__list">
        {!!message && <li className="ActionSheetModal__message__message">{message}</li>}
        {optionsList
          ? optionsList.map((item) => (
              // biome-ignore lint/a11y/useKeyWithClickEvents: existing functionality; refactor needed
              <li
                key={item.label}
                onClick={() => {
                  item.action();
                  onClose();
                }}
                className={`ActionSheetModal__action ActionSheetModal__action${
                  item.destructive && '__destructive'
                }`}
              >
                {item.label}
              </li>
            ))
          : null}
        {children && children}
      </ol>
      {showCancel && (
        <ol className="ActionSheetModal__list">
          {/** biome-ignore lint/a11y/useKeyWithClickEvents: existing functionality; refactor needed */}
          <li className="ActionSheetModal__cancel" onClick={onClose}>
            Cancel
          </li>
        </ol>
      )}
    </Modal>
  );
};
